import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }, { fill, hasTitle }: { fill: boolean; hasTitle: boolean }) => {
  return {
    container: css`
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.05);
      padding: 15px 24px;
    `,
    fillContainer: fill
      ? css`
          height: 100%;
          overflow: auto;
          display: flex;
          flex-direction: column;
        `
      : {},
    title: css`
      font-size: 16px;
      line-height: 16px;
      font-weight: 700;
      position: relative;
      padding-left: 10px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 2px;
        background: ${token.colorPrimary};
      }
    `,
    header: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,
    fill: fill
      ? css`
          flex: 1;
          height: ${hasTitle ? 'calc(100% - 36px)' : '100%'};
        `
      : {},
    warp: fill
      ? css`
          height: 100%;
          overflow: hidden;
        `
      : {}
  };
});
